import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import GenStyles from "./styles/GenStyles.module.css";
import LoginPage from "./login_module";
import {useUser} from "./UserContext";
import LoginModule from "./login_module";
import StudentTestSelector from "./components/StudentTestSelector";
import { talk } from "./ALI_Ajax";
import { useConfirm } from "./components/ConfirmDialog";

const Home = (props) => {
    const {firstName, logoutTimer, is_user_in_role, finishedLoggingIn, userId} = useUser();
    const [testsAvailable, setTestsAvailable] = useState([]);
    const [selectedTest, setSelectedTest] = useState(false);
    const navigate = useNavigate();
    const confirm = useConfirm();

    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    // Triggers when user info changes (i.e. login or check status is finished)
    useEffect(() => {
        if(is_user_in_role(['EXAMINEE'])) {
            getAvailableTests();
        }

    }, [userId]);



    const getAvailableTests = () => {
        console.log("Loading tests");
        talk(
            "ali_api/ALITests_Handler.php",
            "GET_TEST_ASSIGNMENT_DATA_FOR_EXAMINEE",
            {user_id: userId},
            getAvailableTestsHandler
        )
    }
    const getAvailableTestsHandler = (operation, sentData, returnData) => {
        console.log(returnData);

        if(returnData['uncompleted_tests']['status'] === 'success') {
            setTestsAvailable(returnData['uncompleted_tests']['message'].concat(returnData['completed_tests']['message']));
        }
    }
    const startTest = async (testInfo) => {
        const ok = await confirm({
            title: "Start this test?",
            body: "Once you begin, the timer starts.",
            confirmText: "Start now",
            cancelText: "Not yet",
            tone: "primary",
        });

        if (!ok) return;

        setBusy(true); setErr("");

        talk(
            "ali_api/handlers/TestHandler.php",
            "INITIALIZE_TEST",
            {testInfo: testInfo},
            startTestHandler
        )
    }
    const startTestHandler = (operation, sentData, returnData) => {
        console.log(returnData);

        if(returnData['status'] === 'success') {
            // Navigate to Take Test
            navigate("take_test");
        } else {
            // Error handling
        }
    }

    return (
        <>
            {
                finishedLoggingIn ?
                <>
                    {/* Header */}
                    <div className={GenStyles.welcome_line}>Welcome, {firstName}!</div>
                    <div className={GenStyles.container} style={{marginTop: "80px"}} id="showcase">
                        <h1 className={GenStyles.jumbo}><b>ALI</b></h1>
                        <h1 className={`${GenStyles.xxxlarge} ${GenStyles.text_umkc_blue}`}><b>Applied Language Institute</b></h1>
                        <hr style={{width: "50px", border: "5px solid #ffd52f"}} className={GenStyles.round}/>
                    </div>

                    {firstName ?
                        is_user_in_role(['EXAMINEE']) ?
                            <StudentTestSelector
                                testsAvailable={testsAvailable}
                                onStartTest={startTest}
                            />
                            : <>Not updated</>
                     : <LoginModule />}
                </> :
                <div>loading</div>
            }
        </>
    );
}

export default Home;
